"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _shopList = require("@/api/shop/shopList");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BatchSettingLog',
  data: function data() {
    return {
      searchForm: {
        batchNo: '',
        storeName: '',
        operationType: '',
        operationResult: null
      },
      tableData: [],
      loading: false,
      page: 1,
      limit: 20,
      total: 0,
      detailDialogVisible: false,
      currentRow: null
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var params = _objectSpread({
        page: this.page,
        limit: this.limit
      }, this.searchForm);
      (0, _shopList.getBatchSettingLogPage)(params).then(function (res) {
        _this.tableData = res.records || [];
        _this.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        batchNo: '',
        storeName: '',
        operationType: '',
        operationResult: null
      };
      this.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getOperationTypes: function getOperationTypes(typeStr) {
      if (!typeStr) return [];
      return typeStr.split(',').filter(function (t) {
        return t.trim();
      });
    },
    getOperationTagType: function getOperationTagType(type) {
      var typeMap = {
        '推送设置': 'primary',
        '开票配置': 'success',
        '外卖运费设置': 'warning',
        '营业时间配置': 'info',
        '周期运费配置': 'danger',
        '公告设置': '',
        '福利社图片': ''
      };
      return typeMap[type] || '';
    },
    formatDateTime: function formatDateTime(dateStr) {
      if (!dateStr) return '-';
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    formatJson: function formatJson(jsonStr) {
      if (!jsonStr) return '-';
      try {
        var obj = JSON.parse(jsonStr);
        // 格式化对象中的日期时间字段
        var formattedObj = this.formatJsonDates(obj);
        return JSON.stringify(formattedObj, null, 2);
      } catch (e) {
        return jsonStr;
      }
    },
    // 递归格式化JSON中的日期字段
    formatJsonDates: function formatJsonDates(obj) {
      var _this2 = this;
      if (!obj || (0, _typeof2.default)(obj) !== 'object') {
        return obj;
      }
      if (Array.isArray(obj)) {
        return obj.map(function (item) {
          return _this2.formatJsonDates(item);
        });
      }
      var result = {};
      for (var key in obj) {
        var value = obj[key];
        if (typeof value === 'string') {
          if (this.isIsoDate(value)) {
            // 是ISO日期，直接格式化
            result[key] = this.formatDateTime(value);
          } else if (this.mightBeJson(value)) {
            // 尝试解析为JSON（处理双重JSON字符串的情况）
            try {
              var parsed = JSON.parse(value);
              // 递归格式化内部JSON中的日期，然后转回字符串
              var formattedInner = this.formatJsonDates(parsed);
              result[key] = JSON.stringify(formattedInner);
            } catch (_unused) {
              // 不是JSON，保持原样
              result[key] = value;
            }
          } else {
            result[key] = value;
          }
        } else if ((0, _typeof2.default)(value) === 'object' && value !== null) {
          result[key] = this.formatJsonDates(value);
        } else {
          result[key] = value;
        }
      }
      return result;
    },
    // 判断字符串可能是JSON（以{或[开头）
    mightBeJson: function mightBeJson(str) {
      if (!str || typeof str !== 'string') return false;
      var trimmed = str.trim();
      return trimmed.startsWith('{') && trimmed.endsWith('}') || trimmed.startsWith('[') && trimmed.endsWith(']');
    },
    // 判断是否是ISO日期格式
    isIsoDate: function isIsoDate(str) {
      if (!str || typeof str !== 'string') return false;
      // ISO 8601格式: 2026-04-13T05:54:27.000Z 或 2026-04-14T08:13:17.000Z
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(str);
    },
    showDetailDialog: function showDetailDialog(row) {
      this.currentRow = row;
      this.detailDialogVisible = true;
    }
  }
};